// https://github.com/alphagov/govuk-frontend/blob/master/src/components/table/_table.scss

import styled from 'styled-components';

const TableBody = styled('tbody')({});

export default TableBody;
